import { IAppState } from '../../../redux';
import { IOfferGeoEditRestriction } from '../../../redux/reducers';

export const selectAddressEditingRestrictionData = (state: IAppState): IOfferGeoEditRestriction | null => {
  return state.offer.geo?.editRestriction || null;
};
